import React from 'react'
import Slider from 'react-slick';
import Loading from '../Loading/Loading';
import Error from '../Error/Error';
import useAllCatergories from '../../hooks/useAllCategories';

export default function CategorySlider() {

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1
  };


  const { isLoading, isError, data } = useAllCatergories()
  return <>
    <div className="py-3">
      {isLoading && <Loading />}
      <Slider {...settings}>
        {data?.data.data.map(category => <img height={200} key={category._id} src={category.image} alt={category.name} />)}
      </Slider>
      {isError && <Error />}

    </div>

  </>


}
